!customElements.get('op-plp-filters') && customElements.define('op-plp-filters', class extends HTMLElement {

    // constructor(){
    //     super();
    //     this.opModalBody = this.querySelector(".tw-op-modal-body");
    //     this.opModalCloser = this.querySelector("op-modal-closer");
    // }

    connectedCallback() {
        this.activeCurrency = window.Shopify?.currency?.active?.toLowerCase();
        this.dialog = this.closest("dialog");
        this.displayFacets = [];
        this.facets = [];
        this.lastFilters = null;
        this.lastIndex = null;
        this.maxHits = 0;
        this.widgets = [];
        this.multiChoiseTemplate = this.querySelector("[data-multichoice-acc]");
        this.checkboxOptionTemplate = this.querySelector("[data-checkbox-option]");
        this.form = this.querySelector("form");
        this.resultCountDisplay = this.querySelector("[data-result-count]");
        this.filterBy = this.form?.elements.namedItem("filter_by");
        this.sortOptionTemplate = this.querySelector("[data-sort-option]");
        this.sortByContent = this.querySelector("[data-sort-by-content]");
        this.pendingPreviewTimeout = null;
        this.previewDelayMs = 250;

        this.config = JSON.parse(this.querySelector("script[type='application/json']")?.textContent || "{}");
        this.facetTitles = this.config.titles || {};
        this.facetsBlacklist = this.config.blacklist || [];

        this.filtersObjects = [];

        if (this.form) {
            this.form.addEventListener("submit", this.form_submitHandler);
            this.form.addEventListener("reset", this.form_resetHandler);
            this.form.addEventListener("change", this.form_changedHandler);
        }

        document.addEventListener("plp:facets-loaded", this.plpFacetsLoaded_handler);
        document.addEventListener("plp:clear-filters", this.plpResetFilters_handler);
        document.addEventListener("plp:open-filters", this.plpOpenFilters_handler);
        document.addEventListener("plp:facets-updated", this.plpFacetsUpdated_handler);
        document.addEventListener("plp:facet-count-updated", this.plpFacetsCountUpdated_handler);
        this.dialog?.addEventListener("toggle", this.dialog_toggleHandler);
        this.dialog?.addEventListener("close", this.dialog_closeHandler);
        // this.handleModalCloserLayout();
    }

    // handleModalCloserLayout() {
    //     this.opModalBody.addEventListener('scroll', () => {
    //        if(this.opModalBody.scrollTop > 0) {
    //             this.opModalCloser.classList.add('tw-bg-white')
    //        } else {
    //             this.opModalCloser.classList.remove('tw-bg-white')
    //        }
    //     })
    // }

    disconnectedCallback() {
        if (this.form) {
            this.form.removeEventListener("submit", this.form_submitHandler);
            this.form.removeEventListener("reset", this.form_resetHandler);
            this.form.removeEventListener("change", this.form_changedHandler);
        }

        document.removeEventListener("plp:facets-loaded", this.plpFacetsLoaded_handler);
        document.removeEventListener("plp:clear-filters", this.plpResetFilters_handler);
        document.removeEventListener("plp:open-filters", this.plpOpenFilters_handler);
        document.removeEventListener("plp:facets-updated", this.plpFacetsUpdated_handler)
        this.dialog?.removeEventListener("toggle", this.dialog_toggleHandler);
        this.dialog?.removeEventListener("close", this.dialog_closeHandler);
        this.clearPendingPreview();
    }

    clearPendingPreview () {
        if (this.pendingPreviewTimeout) {
            clearTimeout(this.pendingPreviewTimeout);
            this.pendingPreviewTimeout = null;
        }
    }

    schedulePreviewUpdate () {
        this.clearPendingPreview();
        this.pendingPreviewTimeout = setTimeout(() => {
            this.pendingPreviewTimeout = null;
            this.submitFilters(false, false);
        }, this.previewDelayMs);
    }

    createCheckboxOption (template, name = "", value = "", count = 0) {
        const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "").trim();
        const metaHandle = `${name.replace("meta.custom.", "").replaceAll("_", "-")}-${sanitizedValue.replaceAll(" ", "-")}`.toLowerCase();
        const metaObj = this.filtersObjects.find(o => o.handle === metaHandle || o.id === value);
        const checkboxLabel = metaObj?.label?.value || metaObj?.fields?.[0]?.value || sanitizedValue;

        const clone = template.content.cloneNode(true);
        
        const labelEl = clone.querySelector("[data-cb-label]");
        const checkbox = clone.querySelector("input[type='checkbox']");
        const iconEl = clone.querySelector("[data-cb-icon]");
        const descriptionEl = clone.querySelector("[data-cb-description]");

        if (labelEl) {
            labelEl.textContent = checkboxLabel;
        }

        if (checkbox) {
            checkbox.name = name;
            checkbox.value = value;
            checkbox.dataset.count = count;
            checkbox.dataset.metaHandle = metaHandle;
            checkbox.ariaLabel = checkboxLabel;
            checkbox.dataset.tealiumValue = value.toLowerCase().replaceAll(" ", "");
        }

        if (iconEl) {
            if (metaObj?.image?.reference?.image?.url) {
                iconEl.style.backgroundImage = `url(${metaObj.image.reference.image.url})`;
                iconEl.removeAttribute("data-hidden");
            }
            else if (metaObj?.color?.value) {
                iconEl.style.backgroundColor = metaObj.color.value;
                iconEl.removeAttribute("data-hidden");
            }
            else {
                iconEl.toggleAttribute("data-hidden", true);
            }
        }

        clone.hasDescription = false;

        if (descriptionEl) {
            if (metaObj?.description?.value) {
                descriptionEl.textContent = metaObj.description.value;
                descriptionEl.removeAttribute("data-hidden");
                clone.hasDescription = true;
            } else {
                descriptionEl.textContent = "";
                descriptionEl.toggleAttribute("data-hidden", true);
            }
        }
        
        return clone;
    }

    /**
     * Serializes the filter form control states (checkboxes, radios) for cancel/revert.
     * @returns {Array<{ name: string, value: string, checked: boolean, type: string }>}
     */
    getFormInputsSnapshot () {
        const entries = [];
        if (!this.form) {
            return entries;
        }
        for (const el of this.form.querySelectorAll("input")) {
            if (el.name?.startsWith("_") || el.type === "hidden") {
                continue;
            }
            if (el.type === "checkbox" || el.type === "radio") {
                entries.push({ name: el.name, value: el.value, checked: el.checked, type: el.type });
            }
        }
        return entries;
    }

    /**
     * @param {Array<{ name: string, value: string, checked: boolean, type: string }>} inputEntries
     * @returns {boolean} Whether each captured control still matches the current form.
     */
    formInputsMatchSnapshot (inputEntries) {
        if (!this.form || !Array.isArray(inputEntries)) {
            return true;
        }
        return inputEntries.every((s) => {
            const el = this.form.querySelector(
                `input[type='${s.type}'][name='${CSS.escape(s.name)}'][value='${CSS.escape(s.value)}']`
            );
            return el && el.checked === s.checked;
        });
    }

    /**
     * Restores form controls from a snapshot (used when closing the panel without applying).
     * @param {Array<{ name: string, value: string, checked: boolean, type: string }>} inputEntries
     */
    applyFormInputsFromSnapshot (inputEntries) {
        if (!this.form || !Array.isArray(inputEntries)) {
            return;
        }
        for (const s of inputEntries) {
            const el = this.form.querySelector(
                `input[type='${s.type}'][name='${CSS.escape(s.name)}'][value='${CSS.escape(s.value)}']`
            );
            if (el) {
                el.checked = s.checked;
            }
        }
    }

    /**
     * Updates accordion (facet) count displays after bulk checkbox changes.
     */
    refreshFieldsetAccordionsAfterFormChange () {
        if (!this.form) {
            return;
        }
        this.form.querySelectorAll("fieldset").forEach((fieldset) => {
            const checkboxes = fieldset?.querySelectorAll("input[type='checkbox']");
            const counterDisplay = fieldset?.querySelector("[data-acc-counter]");
            let checkedCount = 0;
            checkboxes?.forEach((checkbox) => {
                if (checkbox.checked) {
                    checkedCount++;
                }
            });
            this.updateCounterDisplay(counterDisplay, checkedCount);
        });
    }

    /**
     * Captures applied filters + UI state when the sort/filter panel is opened, for revert on close without apply.
     */
    capturePanelOpenSnapshot () {
        if (!this.form) {
            this._panelOpenSnapshot = null;
            return;
        }
        this._panelOpenSnapshot = {
            lastFilters: this.lastFilters,
            lastIndex: this.lastIndex,
            inputs: this.getFormInputsSnapshot(),
            resultCount: Number(this.resultCountDisplay?.dataset?.resultCount) || 0
        };
    }

    /**
     * When the user closes the dialog without using RESULTS or RESET, restores the listing + form to the pre-open state.
     */
    dialog_closeHandler = () => {
        this.clearPendingPreview();

        if (this._filterPanelCloseCommitted) {
            this._filterPanelCloseCommitted = false;
            this._panelOpenSnapshot = null;
            return;
        }

        const snap = this._panelOpenSnapshot;
        this._panelOpenSnapshot = null;

        if (!this.form || !snap) {
            return;
        }

        const formMatches = this.formInputsMatchSnapshot(snap.inputs);
        const searchMatches = this.lastFilters === snap.lastFilters && this.lastIndex === snap.lastIndex;

        if (formMatches && searchMatches) {
            return;
        }

        this.applyFormInputsFromSnapshot(snap.inputs);
        this.lastFilters = snap.lastFilters;
        this.lastIndex = snap.lastIndex;

        if (searchMatches) {
            this.updateWidgets();
            this.refreshFieldsetAccordionsAfterFormChange();
            this.updateResultHitsCount(snap.resultCount);
            return;
        }

        this.updateWidgets();
        this.refreshFieldsetAccordionsAfterFormChange();
        this.updateResultHitsCount(snap.resultCount);
    }

    dialog_toggleHandler = (event) => {
        if (event.newState === "open") {
            this._filterPanelCloseCommitted = false;
            this.capturePanelOpenSnapshot();
            if (this.facets.length === 0) {
                this.updateFacets(this.getLastResultFacets(), false);
            }
        }
    }

    dispatchFiltersChanged (facetsFilters = [], index, showResults, tealiumFacets = [], sendTealiumData = false) {
        const joinedFilters = facetsFilters.length > 0 ? facetsFilters.join(",") : null;
        const selFacets = facetsFilters.length > 0 ? this.facets.map(f => f.name) : [];

        if (this.lastFilters !== joinedFilters || this.lastIndex !== index || showResults) {
            document.dispatchEvent(new CustomEvent("plp:filters-changed", {
                detail: { selFacets, facetsFilters, index, showResults, tealiumFacets, sendTealiumData }
            }));

            this.lastFilters = joinedFilters;
            this.lastIndex = index;
        }
    }

    async fetchFiltersMetaObj () {
        const { url, token } = window.storefront;
        const country = window.Shopify?.country?.toUpperCase() || "US";
        const language = window.Shopify?.locale?.toUpperCase() || "EN";
        const objects = [];
        let hasNextPage = true;
        let cursor;

        while (hasNextPage) {
            const res = await Fetchutils.postGraphql(url, token, `#graphql
                query loadPlpFilters @inContext(country: ${country}, language: ${language}) {
                    metaobjects (type: "plp_filters", first: 250, after: ${cursor ? `"${cursor}"` : "null"}) {
                        nodes {
                            id
                            handle
                            label: field(key: "label") {
                                value
                            }
                            image: field(key: "image") {
                                value
                                reference {
                                    ... on MediaImage {
                                        image {
                                            url
                                        }
                                    }
                                }
                            }
                            color: field(key: "color") {
                                value
                            }
                            description: field(key: "description") {
                                value
                            }
                        }
                        pageInfo {
                            hasNextPage
                            endCursor
                        }
                    }
                }
            `);

            const nodes = res.data?.metaobjects?.nodes;

            if (Array.isArray(nodes)) {
                objects.push(...nodes);
            }

            if (res.errors) {
                console.error(res.errors);
                break;
            }

            hasNextPage = res.data?.metaobjects?.pageInfo?.hasNextPage;
            cursor = res.data?.metaobjects?.pageInfo?.endCursor;
        }

        return objects;
    }

    async fetchMetaobject (id) {
        const { url, token } = window.storefront;
        const country = window.Shopify?.country?.toUpperCase() || "US";
        const language = window.Shopify?.locale?.toUpperCase() || "EN";

        const res = await Fetchutils.postGraphql(url, token, `#graphql
            query getMetaobject @inContext(country: ${country}, language: ${language}) {
                metaobject(id: "${id}") {
                    id
                    handle
                    label: field(key: "title") {
                        value
                    }
                    description: field(key: "description") {
                        value
                    }
                    fields {
                        key
                        value
                    }
                }
            }
        `);

        if (res.errors) {
            console.error(res.errors);
            return null;
        }

        return res.data?.metaobject;
    }

    form_changedHandler = (event) => {
        const fieldset = event.target.closest("fieldset");
        const checkboxes = fieldset?.querySelectorAll("input[type='checkbox']");
        const counterDisplay = fieldset?.querySelector("[data-acc-counter]");

        let checkedCount = 0;

        checkboxes?.forEach(checkbox => {
            if (checkbox.checked) {
                checkedCount++;
            }
        });

        this.updateCounterDisplay(counterDisplay, checkedCount);
        this.schedulePreviewUpdate();
    }

    form_resetHandler = () => {
        this._filterPanelCloseCommitted = true;
        this.clearPendingPreview();
        this.dispatchFiltersChanged([], null, true, [], true);

        this.form.querySelectorAll("[data-acc-counter]").forEach(counter => {
            this.updateCounterDisplay(counter, 0);
        });

        this.dialog?.close();
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, 200);
    }

    form_submitHandler = (event) => {
        this._filterPanelCloseCommitted = true;
        this.clearPendingPreview();
        this.submitFilters(true, true);
        event.preventDefault();
        this.dialog?.close();
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, 200);
    }

    getLastResultFacets () {
        const lastResults = window.algoliaShopify?.instantsearch?.search?.helper?.lastResults;
        const rawResultFacets = lastResults?._rawResults[0]?.facets || {};
        const facetNames = Object.keys(rawResultFacets);
        
        if (facetNames.length > 0) {
            return facetNames.map(name => ({ name, data: rawResultFacets[name] }));
        }

        return lastResults?.facets || [];
    }

    getGroupedFormValues (formData) {
        const groupedValues = new Map();

        for (const [key, value] of formData.entries()) {
            if (key === "sort_by" || key.startsWith("_") || !value) continue;

            if (!groupedValues.has(key)) {
                groupedValues.set(key, []);
            }

            groupedValues.get(key).push(value);
        }

        return Array.from(groupedValues, ([key, values]) => ({ key, values }));
    }

    getCheckboxByValue (name, value) {
        const checkboxes = this.form?.querySelectorAll("input[type='checkbox']");

        return Array.from(checkboxes || []).find(checkbox => (
            checkbox.name === name && checkbox.value === String(value)
        ));
    }

    submitFilters (showResults, sendTealiumData = false) {
        const formData = new FormData(this.form);
        const facetsFilters = [];
        const tealiumFacets = [];
        const sortBy = formData.get("sort_by");

        //get filters value from form data and format them for dispatch for update widget and tealium
        for (const { key, values } of this.getGroupedFormValues(formData)) {
            facetsFilters.push(values.map(entry => `${key}:${entry}`));
            tealiumFacets.push(
                values.map(entry => {
                    const checkbox = this.getCheckboxByValue(key, entry);
                    //remove meta.custom. from facet key for tealium
                    const formattedKey = key.replace("meta.custom.", "");
                    return `${formattedKey}:${checkbox?.dataset.tealiumValue || entry}`;
                })
            );
        }

        this.dispatchFiltersChanged(facetsFilters, sortBy, showResults, tealiumFacets, sendTealiumData);
    }

    widget_transitionEndHandler = (event) => {
        if (window.navigator.maxTouchPoints > 0 && event.currentTarget?.querySelector("details")?.open) {
            event.currentTarget.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    getFacetTitle (facetName) {
        return this.facetTitles[facetName] || this.displayFacets.find(df => df.name === facetName)?.title || facetName;
    }

    isStaticFilter (facet) {
        return facet.data && Object.keys(facet.data).length < 3 && this.filterBy?.elements.namedItem(facet.name);
    }

    isDisplayedFacet (facetName) {
        return !this.config.onlyDisplayFacets || this.displayFacets.some(df => df.enabled && df.name === facetName && df.type !== "hidden");
    }

    async loadFilterMetaObj () {
        const objects = [];

        try {
            const objlist = await this.fetchFiltersMetaObj();
            objects.push(...objlist);
        } catch (error) {
            console.error("Error loading filter meta object:", error);
        }

        for (const facet of this.facets) {
            if (!facet.data) continue;

            for (const value in facet.data) {
                if (!value.startsWith("gid://shopify/Metaobject/")) continue;

                try {
                    const metaObj = await this.fetchMetaobject(value);

                    if (metaObj) {
                        objects.push(metaObj);
                    }
                } catch (error) {
                    console.error("Error loading meta object for value:", value, error);
                }
            }
        }

        return objects;
    }

    plpFacetsLoaded_handler = (event) => {
        if (this.facets.length === 0 || !this.lastFilters) {
            this.updateFacets(this.getLastResultFacets(), false, event.detail.facetOrdering);
            this.maxHits = event.detail.maxHits || 0;
        }
    }

    plpFacetsUpdated_handler = (event) => {
        const savedFacets = JSON.parse(sessionStorage.getItem("plpFacets"));
        const initialFacets = Array.isArray(savedFacets) ? savedFacets : this.facets;
        const results = event.detail.results || [];
        const newFacets = [];

        for (let facet of initialFacets) {
            const facetData = facet.data;
            let disabled = false;

            for (let result of results) {
                const params = new URLSearchParams(result.params);

                if (params.get("facetFilters")?.includes(facet.name)) {
                    continue;
                }

                if (!result.facets) {
                    console.warn("No facets in result for:", params.get("facetFilters"));
                    continue;
                }
                
                if (!result.facets[facet.name]) {
                    disabled = true;
                    continue;
                }

                for (let value of Object.keys(facetData)) {
                    const count = result.facets[facet.name][value];

                    if (!count) {
                        delete facetData[value];
                        continue;
                    }

                    if (count < facetData[value]) {
                        facetData[value] = count;
                    }
                }
            }

            if (!disabled) {
                newFacets.push(facet);
            }
        }

        this.updateFacets(newFacets, true);
    }

    plpFacetsCountUpdated_handler = (event) => {
        this.updateResultHitsCount(event.detail.nbHits);
    }

    plpResetFilters_handler = () => {
        this.form?.reset();
        this.form_resetHandler();
    }

    plpOpenFilters_handler = () => {
        this.dialog?.showModal();
    }

    renderWidgets () {
        if (!this.form) {
            console.error("Form container not found for PLP filters.");
            return;
        }

        if (!this.multiChoiseTemplate) {
            console.error("Multi-choice template not found for PLP filters.");
            return;
        }

        if (!this.checkboxOptionTemplate) {
            console.error("Checkbox option template not found for PLP filters.");
            return;
        }

        this.updateSortByOptions();

        this.widgets.forEach(w => {
            w.removeEventListener("transitionend", this.widget_transitionEndHandler);
            w.remove();
        });

        this.widgets.length = 0;

        for (let facet of this.facets) {
            if (this.facetsBlacklist.includes(facet.name) || !this.isDisplayedFacet(facet.name) || this.isStaticFilter(facet)) {
                continue;
            }

            const facetName = facet.name;
            const clone = this.multiChoiseTemplate.content.cloneNode(true);
            const widget = clone.querySelector("[data-facet]");
            const accTitle = clone.querySelector("[data-acc-title]");
            const accContent = clone.querySelector("[data-acc-content]");
            
            widget.addEventListener("transitionend", this.widget_transitionEndHandler);
            widget.dataset.facet = facetName;
            accTitle.textContent = this.getFacetTitle(facetName);
            accContent.toggleAttribute("data-has-description", false);
            for (let value in facet.data) {
                const count = facet.data[value];
                const cbOpt = this.createCheckboxOption(this.checkboxOptionTemplate, facetName, value, count);
                
                if (cbOpt.hasDescription) {
                    accContent.toggleAttribute("data-has-description", true);
                }
                
                accContent.appendChild(cbOpt);
            }

            this.widgets.push(widget);
            this.form.appendChild(widget);
        }

        this.updateWidgets();
        this.updateResultHitsCount(this.maxHits);
        if (this.dialog?.open) {
            this.capturePanelOpenSnapshot();
        }
    }

    updateCounterDisplay (display, count) {
        if (display) {
            display.textContent = count > 0 ? `(${count})` : '';
            display.dataset.accCounter = count;
            display.toggleAttribute("data-hidden", count === 0);
        }
    }

    updateFacets (newFacets, preventRender, facetOrdering) {
        const displayFacets = window.algoliaShopify?.facets;

        if (Array.isArray(newFacets) && Array.isArray(displayFacets)) {
            this.facets = newFacets;
            // Reorder facets based on facetOrdering
            if (facetOrdering && Array.isArray(facetOrdering)) {
                this.facets.sort((a, b) => {
                    const indexA = facetOrdering.indexOf(a.name);
                    const indexB = facetOrdering.indexOf(b.name);
                    return indexA - indexB;
                });
            }
            this.displayFacets = displayFacets;

            if (!this.lastIndex) {
                this.lastIndex = window.algoliaShopify?.instantsearch?.search?.helper?.lastResults?.index;
            }

            if (this.lastFilters || preventRender) {
                this.updateWidgets();
                return;
            }

            sessionStorage.setItem("plpFacets", JSON.stringify(this.facets));

            if (this.filtersObjects.length === 0 && window.storefront) {
                this.loadFilterMetaObj().then(objects => {
                    this.filtersObjects = objects;
                    this.renderWidgets();
                });
            } else {
                this.renderWidgets();
            }
        }
    }

    updateWidgets () {
        if (!this.form) return;

        for (let element of this.form.elements) {
            const facet = this.facets.find(f => f.name === element.name);
            const facetData = facet?.data;
            
            if (facetData && this.filterBy?.contains(element)) {
                if (Object.keys(facetData).some(key => key.toLowerCase() === element.value.toLowerCase())) {
                    element.disabled = false;
                } else {
                    element.disabled = true;
                    element.checked = false;
                }

                continue;
            }
            
            if (this.displayFacets.some(df => df.name === element.name) && element.dataset.count) {
                if (facetData && facetData[element.value]) {
                    element.dataset.count = facetData[element.value];
                    element.disabled = false;
                } else {
                    element.dataset.count = 0;
                    element.disabled = true;
                    element.checked = false;
                }

            }
        }
    }

    updateResultHitsCount (count) {
        if (this.resultCountDisplay) {
            this.resultCountDisplay.textContent = `(${count})`;
            this.resultCountDisplay.dataset.resultCount = count;
            this.resultCountDisplay.toggleAttribute("data-hidden", !count);
        }
    }

    updateSortByOptions () {
        const labels = this.config.sortByLabels || {};
        let options = window.algoliaShopify?.sortOrders;

        if (Array.isArray(options) && this.sortOptionTemplate && this.sortByContent) {
            this.sortByContent.querySelectorAll("label").forEach(label => label.remove());

            if (this.config.filterSortOrdersByCurrency) {
                options = options.filter(({ value = "" }) => (
                    !value.includes("pricing_") || value.includes(`_${this.activeCurrency}`) 
                ));
            }

            options.forEach(option => {
                const clone = this.sortOptionTemplate.content.cloneNode(true);

                const input = clone.querySelector("input");
                const labelEl = clone.querySelector("[data-sort-label]");
                const marketId = window.algoliaShopify?.shopify.market.id;
                const currentMarket = window.algoliaShopify?.config?.markets_mapping?.find(market => Number(market.id) === Number(marketId));

                // Change most popular index
                if(option.label == 'most_popular' && currentMarket) {
                    if(currentMarket.suffix && currentMarket.suffix !== '') {
                        option.value = `production_products_${currentMarket.suffix}_newreleases`
                    } else {
                        option.value = `production_products_newreleases`
                    }
                }

                // Remove currency from label for pricing options for translations (e.g., "Price (USD)" -> "price")
                const optLabel = this.config.filterSortOrdersByCurrency && (option.value?.includes("pricing_") || option.value?.includes("price_"))
                    ? option.label?.toLowerCase()?.replace(`(${this.activeCurrency})`, "")?.trim()?.replaceAll(" ", "_")
                    : option.label?.toLowerCase()?.replaceAll(" ", "_");

                //if market is US pricing sort should be production_products_price_asc or production_products_price_desc
                if(Shopify.country === "US" && (option.value.includes("price_asc"))) {
                    option.value = "production_products_price_asc";
                }
                else if(Shopify.country === "US" && (option.value.includes("price_desc"))) {
                    option.value = "production_products_price_desc";
                }

                const labelText = labels[optLabel] || option.label;

                if (input) {
                    input.value = option.value;
                    input.name = "sort_by";
                    input.checked = this.lastIndex === option.value;
                    input.ariaLabel = labelText;
                    input.dataset.optLabel = optLabel;
                }

                if (labelEl) {
                    labelEl.textContent = labelText;
                }

                this.sortByContent.appendChild(clone);
            });
        }
    }
});
